import { Injectable } from '@angular/core';
import { Observable, of, delay } from 'rxjs';
import ApiOptionsConfig from '../api-options.config';
import { ApiBaseService } from '../api-base.service';
const BASE_URL = '/item-products';

@Injectable({
  providedIn: 'root'
})
export class ItemProductsService extends ApiBaseService {

  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }

  detail(itemProductsId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${itemProductsId}`), options?.params);
  }

  create(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL), data);
  }

  update(itemProductsId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${itemProductsId}`), data);
  }

  delete(itemProductsId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${itemProductsId}`));
  }

}
